import { FC, ReactNode } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/ActionMenu/ActionMenuItem.styl'

export type ActionMenuItemProps = {
  icon?: ReactNode
  isDisabled?: boolean
  isActive?: boolean
  isDanger?: boolean
  isHighlighted?: boolean
  hint?: string
  fullWidth?: boolean
  preventHover?: boolean

  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  onMouseMove?: () => void
}

export const ActionMenuItem: FC<ActionMenuItemProps> = (props) => {
  const {
    onClick,
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
    icon,
    children,
    isDisabled = false,
    isActive,
    isDanger,
    isHighlighted,
    hint,
    fullWidth,
    preventHover,
  } = props

  const containerClassname = cn(styles.container, {
    [styles.isDisabled]: isDisabled,
    [styles.isActive]: isActive,
    [styles.isDanger]: isDanger,
    [styles.isHighlighted]: isHighlighted,
    [styles.fullWidth]: fullWidth,
    [styles.preventHover]: preventHover,
  })

  return (
    <button
      className={ containerClassname }
      onClick={ isDisabled ? undefined : onClick }
      onMouseEnter={ onMouseEnter }
      onMouseLeave={ onMouseLeave }
      onMouseMove={ onMouseMove }
    >
      { icon && <div className={ styles.icon }>{ icon }</div> }
      <div
        className={ styles.title }
        title={ hint }
      >
        { children }
      </div>
    </button>
  )
}
